// Module
var code = "<div id=\"alertModal\"> <div class=\"modal-body\"><span ng-bind-html=\"msg\"></span> <b>{{countdown.value}}</b></div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default btn-danger\" ng-click=\"close()\">{{'bouton.alt.annuler' | translate}} </button> </div> </div> ";
// Exports
export default code;